import Footer from '@bridebook/web/app-basic/components/footer/footer';
import { TopBar } from '@bridebook/web/app-basic/components/header';
import {
  getActualCategory,
  getFacetsContent,
  getSearchArea,
  getSearchList,
  getTotalResults,
} from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { memo, useMemo } from 'react';
import { getPageSize } from '@bridebook/toolbox/src/search-suppliers/get-page-size';
import type { Slug } from '@bridebook/toolbox/src/types';
import SearchHead from '@bridebook/web/app-shared/components/search-head/search-head';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useSearchPageTitle } from '@bridebook/web/app-shared/lib/search/hooks/use-search-page-title';
import { ILocationData, ISearchPageQuery } from '@bridebook/web/app-shared/lib/search/types';
import { getPrettySupplierCategory } from '@bridebook/web/app-shared/lib/search/utils';
import SearchResultsMicrodata from './search-results-microdata';
import { SearchGridSvgSprite } from './search-svg-sprite';
import SearchList from '@bridebook/web/app-basic/components/search/search';

export interface SearchResultsPageProps {
  locationData: ILocationData | null;
  fullQuery: ISearchPageQuery;
  isNoResultsSearch?: boolean;
  area: string;
  type?: string;
  facetsParams: string[];
}
const SearchResultsPageComponent = ({
  area,
  fullQuery,
  facetsParams,
  locationData,
  type,
  isNoResultsSearch,
}: SearchResultsPageProps) => {
  const totalResults = useSelector(getTotalResults);
  const actualCategory = useSelector(getActualCategory);
  const facetsContent = useSelector(getFacetsContent);
  const market = useMarket();
  const list = useSelector(getSearchList);
  const searchArea = useSelector(getSearchArea);

  const prettyCategory = useMemo(
    () => getPrettySupplierCategory(actualCategory, market, false),
    [actualCategory, market],
  );

  const pageTitle = useSearchPageTitle({
    area: searchArea || area,
    facetsContent,
    facetsParams,
    fullQuery,
    market,
    prettyCategory,
  });

  const pageSize = getPageSize({ isLoggedIn: false });
  const totalPages = useMemo(() => Math.ceil(totalResults / pageSize), [totalResults, pageSize]);

  return (
    <>
      <SearchGridSvgSprite />
      <SearchHead
        locationData={locationData}
        area={area}
        fullQuery={fullQuery}
        facetsParams={facetsParams}
        pageTitle={pageTitle}
        facetsContent={facetsContent}
        list={list}
        actualCategory={actualCategory as Slug}
        market={market}
      />
      <SearchResultsMicrodata title={pageTitle} locationData={locationData} />
      <TopBar />
      <SearchList
        supplierFilterType={type}
        totalResults={totalResults}
        fullQuery={fullQuery}
        totalPages={totalPages}
        locationData={locationData}
        facetsParams={facetsParams}
        prettyCategory={prettyCategory}
        isNoResultsSearch={isNoResultsSearch}
      />
      <Footer />
    </>
  );
};

export const SearchResultsPage = memo(SearchResultsPageComponent);
